'use strict';

/* Controllers */

app.controller('DrinkCartController', ['$scope', '$rootScope', '$location', 'Drink', 'User', 'Cart', 'Payment', 'Venue', 'Helper', 'Braintree', 'Preloader', 'Popup', 
    function ($scope, $rootScope, $location, Drink, User, Cart, Payment, Venue, Helper, Braintree, Preloader, Popup) {

    	// pass service to scope
    	$scope.User  = User;

    	// init scope vars
    	$scope.processing_payment = false;
        $scope.getting_token      = true;
    	$scope.selectedUser       = $rootScope.globals.selectedUser;
    	$scope.selectedVenue      = $rootScope.globals.selectedVenue;
    	$scope.selectedDrink      = $rootScope.globals.selectedDrink;
    	$scope.currency_symbol    = $rootScope.globals.selectedVenue.currency_symbol;

        $scope.venue_fee = Venue.getServiceFee();
    	$scope.discount  = Venue.getDiscount();
    	$scope.total     = Cart.getTotal();
        $scope.selected_drink_price = Drink.getSelectedDrinkPrice();


        if( typeof $rootScope.globals.cartData == 'undefined' ||  
            typeof $rootScope.globals.cartData.personal_message == 'undefined' ){
            
            $rootScope.globals.cartData = {
                personal_message: '',
            };
        }


        // colorize drink images
        Caman('.list-group-item.drink img', function () {
            this.colorize('#ffffff', 100).render();
        });


        // run on page init
        initBraintree();


    	/**
    	 * function that is run when user clicks on
    	 * pay with waave credit button
    	 */
    	$scope.payWithWaaveCredit = function() {
    		// save data to storage
    		Helper.updateLocalStorageWithGlobalVariable();

    		$scope.processing_payment = true;

    		// make payment
    		Payment.make('waave_credit', 'drink', function(resp, status){

    			if( status == 200 ){
    				// success, show receipt to user
    				$location.path('/drink-receipt');
    			}
    			else{
    				// check for errors
                    $scope.handleErrorResponse(resp, status);
    			}

    			$scope.processing_payment = false;
    		});

    	}


        /**
         * function that is run when user clicks on
         * pay with PayPal button
         */
        $scope.payWithPayPal = function(paypal_object) {
            
            // if clicked first init paypal,
            if( typeof paypal_object == 'undefined' ){
                paypal_checkout.paypal.initAuthFlow();
                return;
            }

            // this will run next time this function
            // is called with paypal_object
            
            // save paypal_object in $rootScope
            $rootScope.braintree = {
                paypal_object: paypal_object
            };

            // save data to storage
            Helper.updateLocalStorageWithGlobalVariable();

            $scope.processing_payment = true;

            // make payment
            Payment.make('paypal', 'drink', function(resp, status){

                if( status == 200 ){
                    // success, show receipt to user
                    $location.path('/drink-receipt');
                }
                else{
                    // check for errors
                    $scope.handleErrorResponse(resp, status);
                }

                $scope.processing_payment = false;
            });
        }


        /**
         * function that is run when user clicks on
         * pay with Credit Card button
         */
        $scope.payWithCreditCard = function(){
            Helper.updateLocalStorageWithGlobalVariable();
            
            $location.path('/drink-credit-card-payment');
        }


        /**
         * handle error response
         */
        $scope.handleErrorResponse = function(resp, status){
            switch(status){
                case 402:
                    Popup.error('You need additional WAAVE credits to complete this purchase.');
                    break;

                case 403:
                    Popup.error('Venue has been closed.');
                    break;

                case 406:
                    if( resp.data.message.limit.length !== 0 ){
                        Popup.error('Drink limit count reached.');
                    }
                    else if( resp.data.message.priceChanged.length !== 0 ){   
                        var new_price = resp.data.message.priceChanged[0].price;
                        Popup.error('Drink price has changed to '+$scope.currency_symbol+new_price);

                        Drink.handlePriceChanged(new_price);

                        $scope.selected_drink_price = Drink.getSelectedDrinkPrice();

                        $scope.total = Cart.getTotal();
                    }
                    else if( resp.data.message.unavilable.length !== 0 ){
                        Popup.error('Drink is unavilable.');
                    }

                    break;

                case 410:
                    Popup.error('This venue has been removed.');
                    break;

                default:
                    Popup.error('Something went wrong :(');
                    break;
            }
        }



        /**
         * init braintree on page load
         */
        function initBraintree(){

            Braintree.getToken(function(token, status){

                // check status code
                if( status != 200) {
                    console.info("Couldn't get token, PayPal and Credit Card option will be disabled.");
                    return;
                }

                // init braintree to get nonce
                braintree.setup(token, 'custom', {
                    paypal: {
                        singleUse: true, 
                        amount: $scope.total, 
                        currency: 'SGD', 
                        locale: 'en_us', 
                        headless: true, 
                    },
                    onPaymentMethodReceived: function (obj) {
                        $scope.payWithPayPal(obj);
                    },
                    onReady: function (integration) {
                        paypal_checkout = integration;

                        // braintree is initialized, enable payment buttons
                        $scope.$apply(function(){
                            $scope.getting_token = false;
                        });
                    },
                });
            });

        }


        /**
         * watcher for processing_payment variable
         */
        $scope.$watchGroup(['processing_payment', 'getting_token'], function() {
            if( $scope.processing_payment || $scope.getting_token ){
                Preloader.open();
            }
            else{
                Preloader.close();
            }
        });
        
    }]);